import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { FormArray, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  http = inject(HttpClient);


  public baseUrl: string = environment?.endPoint;
  private accessWithOptions: any
  hideCallBacks = [];
  public currentYear = new Date().getFullYear();
  public currentMonth = new Date().getMonth();
  public currentDate = new Date().getDate();

  showLoader() { /* intentionally empty */ };
  hideLoader() { /* intentionally empty */ };
  public visitcheck = new BehaviorSubject(false);
  constructor() {
    this.accessWithOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'x-access-code': localStorage.getItem('token'),
      }),
    }
  }

  makeRequestWithAction(action: string, params?: any) {
    return this.http.post(this.baseUrl + action, params, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.message || error))
      );
  }

  makeRequestWithActionError(action: string, params?: any) {
    return this.http.post(this.baseUrl + action, params, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }

  uploadImages(action: string, formData: any) {
    return this.http.post(this.baseUrl + action, formData, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.message || error))
      );
  }

  makeGetRequest(action: any) {
    return this.http.get(this.baseUrl + action, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.message || error))
      );
  }

  public makeInsuranceGetRequest(action: string, request: any) {
    return this.http.get(this.baseUrl + action + request)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }

  // Show loader
  show() {
    // const ele =  document.getElementById("spinnerDisplay") as HTMLElement;
    // ele.style.display = "block";
  };
  // Hide loader
  hide() {
    // const ele =  document.getElementById("spinnerDisplay") as HTMLElement;
    // ele.style.display = "none";
    // while (this.hideCallBacks.length > 0) {
    //     let callBack = this.hideCallBacks.pop();
    //     callBack()
    // }
  };
  // resisterHideCallback(callBack: any) {
  //   this.hideCallBacks.push(callBack);
  // }

  // showLoaderNonAPI() {
  //     document.getElementById("loader-wrapper-non-api").style.display = "block";
  // }
  // hideLoaderNonAPI() {
  //     document.getElementById("loader-wrapper-non-api").style.display = "none";
  // }

  // Generate download Image
  public downloadImage(action: string): any {
    const accessWithOptions = {
      // headers: new HttpHeaders({
      //   'Content-Type': 'application/octet-stream'
      // }),
      responseType: 'blob' as 'json'
    }
    return this.http.get(this.baseUrl + action, accessWithOptions)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }

  // Apointment date and time format
  public getAppointmentTime(date: any): string {
    if (date) {
      const splitDate = date?.toString()?.split('T');
      const timeSplit = splitDate[1]?.split(':');
      const time = `${timeSplit[0]}:${timeSplit[1]}`;
      const timeConvert = this.timeConvert(time) || '';
      const formateDate = this.convertAppointmentDate(splitDate && splitDate[0]);
      return `${formateDate}, ${timeConvert}`;
    } else {
      return 'N/A'
    }
  }

  // Apointment date and time format
  public formatDateTimeWithoutAmPm(date: any): string {
    if (date) {
      const splitDate = date?.toString()?.split('T');
      const timeSplit = splitDate[1]?.split(':');
      const time = `${timeSplit[0]}:${timeSplit[1]}`;
      const timeConvert = this.timeConvert(time) || '';
      const formateDate = this.convertAppointmentDate(splitDate && splitDate[0]);
      return `${formateDate} ${timeConvert}`;
    } else {
      return 'N/A'
    }
  }

  public convertAppointmentDate(appntDate: string): any {
    const dateArray = appntDate && appntDate.split('-');
    const dateString = `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
    return dateString;
  }

  // Time converstion from 24hrs format to 12hrs
  public timeConvert(time: any) {
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) { // If time format correct
      time = time.slice(1);  // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  public makePostRequest(action: string, params?: any) {
    return this.http.post(this.baseUrl + action, params, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error?.error || error))
      );
  }
  // billing or cpt code search from treatment flow
  public billingCptCodesTrackBy(term: string): Observable<any> {
    if (!term) {
      return of([]).pipe(delay(500));
    }
    const action = `billingCodes/search/${term}`;
    const subItem = this.makeGetRequest(action);
    return subItem;
  }

  private makeBillingPostCall(action: string, params: any) {
    return this.http.post(this.baseUrl + action, params)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }

  // Calculate AGE
  public calculateAge(dateofBirth: any): number {
    const dobDate = dateofBirth?.includes('T') ? dateofBirth?.split('T')[0] : dateofBirth;
    const date = new Date(dobDate);
    const ageDifMs = Date.now() - date.getTime();
    const ageDate = new Date(ageDifMs);
    const age = Math.abs(ageDate.getUTCFullYear() - 1970);
    return age || 0;
  }

  public convertDate(dob: string | number | Date): any {
    const currentDate = new Date(dob);
    const date = currentDate.getDate();
    const formatedate = ("0" + date).slice(-2);
    const month = currentDate.getMonth() + 1;
    const formateMonth = ("0" + month).slice(-2);
    const year = currentDate.getFullYear();
    const dateString = `${year}-${formateMonth}-${formatedate}`;
    return dateString;
  }

  // get insurance list from the auto complete
  public getInsuranceAutoComplete(term: string): Observable<any> {
    if (!term) {
      return of([]).pipe(delay(500));
    }
    const action = 'insurance/getInsuranceList?searchQry=';
    const insuranceListSub = this.makeInsuranceGetRequest(action, term);
    return insuranceListSub;
  }

  makeRequestWithErrorMessage(action: string, params?: any) {
    return this.http.post(this.baseUrl + action, params, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error?.error || error))
      );
  }


  getPatientsByFacilityId(action: string, facilityid: string) {
    return this.http.get(this.baseUrl + action + facilityid)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }


  // remove timezone from dob
  public formatDobTimeZoneWithDisplay(dob: string): any {
    const split = dob?.includes('T') ? dob?.toString()?.split('T') : dob;
    const date = split && Array.isArray(split) ? split[0] : split;
    const dateChange = date?.includes('-') ? date?.toString()?.split('-') : date;
    return ((dateChange && Array.isArray(dateChange)) ? `${dateChange[1]}/${dateChange[2]}/${dateChange[0]}` : dateChange) || '';
  }

  // common validate 24 hours window
  public async validate24HoursWindowCall(appId: any): Promise<any> {
    const action = `${this.baseUrl}common/validate24hourwindow?appointmentId=${appId}`;
    return this.http?.get<any>(action)?.toPromise();
  }

  public makePostWithFormData(action: any, params: any) {
    const _HttpUploadOptions = {
      headers: new HttpHeaders(
        { "Content-Type": "multipart/form-data", "accept": "application/json" }
      )
    }
    return this.http.post(this.baseUrl + action, params)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }

  public squarePaymentGetRequest(action: any, headers?: any) {
    return this.http.get(action, headers?.headers || this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.message || error))
      );
  }

  // Sqauer Payments
  public squarePaymentPostRequest(action: any, params: any, headers?: any) {
    return this.http.post(action, params, headers?.headers || this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.message || error))
      );
  }

  public downloadProfileImage(action: string): any {
    const accessWithOptions = {
      // headers: new HttpHeaders({
      //   'Content-Type': 'application/octet-stream'
      // }),
      responseType: 'text' as 'json'
    }
    return this.http.get(this.baseUrl + action, accessWithOptions)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }


  // Date of birth Validation
  public validateManualEnterdob(e: any, fieldName: any, form?: FormGroup): void {
    if (e.target.value != '' && e.target.value != null) {
      if (this.validateManualEnterdate(e.target.value, this.currentYear, this.currentMonth + 1, this.currentDate)) {
        form?.get(fieldName)?.setErrors({ invalidDate: true });
      }
    }
  }

  //This method is to validate manually entered date value
  public validateManualEnterdate(enteredDate: any, _currentYear: any, _currentMonth: any, _currentDate: any): boolean {
    const date = new Date(enteredDate);
    const toDayDate = new Date();
    const _dateArray = enteredDate.split('-');
    if (date != undefined && date != null) {
      if (date.getFullYear() < 1910 || date > toDayDate) {
        return true; // Invalid date
      }
      return false
    }
    return false
  }

  yearValidator(control: any) {
    const inputDate = new Date(control.value || control);
    if (isNaN(inputDate.getTime())) {
      return { 'invalidDate': true };
    }
    const minYear = 1900;
    const maxYear = new Date().getFullYear();
    const yearPart = inputDate.getFullYear().toString();
    if (yearPart && yearPart.length > 4) {
      control.setValue(null);
      return { 'invalidDate': true };
    }
    if (inputDate.getFullYear() < minYear || inputDate.getFullYear() > maxYear) {
      // control.setValue(null);
      return { 'invalidDate': true };
    }

    return null;

  }

  // icd codes treatment flow
  public icdCodesTrackByCategory(term: any = null, category?: string): Observable<any> {
    if (!term) {
      return of([]).pipe(delay(500));
    }
    let action = `treatmentFlow/codesCategorySearch?codeSearch=${term}`;
    if (category) {
      action = action + `&category=${category}`;
    }
    const subItem = this.makeGetRequest(action);
    return subItem;
  }

  public getAppointment(date: any): string {
    if (date) {
      const splitDate = date?.toString()?.split('T');
      const timeSplit = splitDate[1]?.split(':');
      const _time = `${timeSplit[0]}:${timeSplit[1]}`;
      const formateDate = this.convertinvoiceDate(splitDate && splitDate[0]);
      return `${formateDate}`;
    } else {
      return 'N/A'
    }
  }

  public getServiceDate(date: any) {
    if (date) {
      const splitDate = date?.toString()?.split('T');
      const timeSplit = splitDate[1]?.split(':');
      const _time = `${timeSplit[0]}:${timeSplit[1]}`;
      const formateDate = this.convertinvoiceDate(splitDate && splitDate[0]);
      return `${formateDate}`;
    } else {
      return null
    }
  }

  public convertinvoiceDate(appntDate: string): any {
    const dateArray = appntDate && appntDate.split('-');
    const dateString = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
    return dateString;
  }

  public patientTrackBy(term: string): Observable<any> {
    if (!term) {
      return of([]).pipe(delay(500));
    }
    let searchParameter: string;
    if (term?.includes(',') || term.includes(' ')) {
      searchParameter = 'fullName';
      if (term?.includes(' ')) {
        const newUserFirstName = term.split(' ')[0];
        const newUserLastName = term.split(' ')[1];
        term = `${newUserLastName},${newUserFirstName}`;
      }
    } else {
      searchParameter = 'lastName';
    }
    const action = `userInfo/patientSearch?searchParameter=${searchParameter || 'lastName'}&searchParameterValue=${term}`;
    const subItem = this.makeRequestWithAction(action, '');
    return subItem;
  }

  public getnewPaymentTime(date: any): string {
    if (date) {
      const splitDate = date?.toString()?.split('T');
      const timeSplit = splitDate[1]?.split(':');
      const time = `${timeSplit[0]}:${timeSplit[1]}`;
      const _timeConvert = this.timeConvert(time) || '';
      const formateDate = this.convertAppointmentDate(splitDate && splitDate[0]);
      return `${formateDate}`;
    } else {
      return 'N/A'
    }
  }

  public convertEpsiodeOfDate(dob: string | number | Date): any {
    const currentDate = new Date(dob);
    const date = currentDate.getDate();
    const formatedate = ("0" + date).slice(-2);
    const month = currentDate.getMonth() + 1;
    const formateMonth = ("0" + month).slice(-2);
    const year = currentDate.getFullYear();
    const dateString = `${year}-${formateMonth}-${formatedate}`;
    return dateString;
  }

  
  //This method is to validate manually entered date value
  public validateManualEnterdateOfBirth(enteredDate: any, _currentYear:any, _currentMonth:any, _currentDate:any): boolean {
    const date = new Date(enteredDate);
    const toDayDate = new Date();
    if (date != undefined && date != null) {
      if (date.getFullYear() < 1910 || date > toDayDate) {
        return true; // Invalid date
      }

      return false; // Valid date
    }
    return true
  }

  public convertVisordob(appntDate: string): any {
    const dateArray = appntDate && appntDate.split('-');
    const dateString = `${dateArray[0]}-${dateArray[1]}-${dateArray[2]}`;
    return dateString;
  }

  
  // due to timezone is added in dob, split and 
  public formatDob(date: string): any {
    if (date != null) {
      const split = date?.includes('T') ? date?.toString()?.split('T') : date;
      const dateSplit = split && split[0] ? split[0] : split;
      return dateSplit || '';
    }
  }


  // Date of birth Validation
  public validateManualEnterdobVisor(e: any, fieldName: any, form?: FormGroup,i?:any): void {
    if (e.target.value != '' && e.target.value != null) {
      if (this.validateManualEnterdate(e.target.value, this.currentYear, this.currentMonth + 1, this.currentDate)) {
        form?.controls[i].get('dupselected')?.setErrors({ invalidDate: true });
      }
    }
  }

  public formateDob(date:any){
    if(date){
    const dateSplit = date?.split('-');
    const year = dateSplit[0];
    const month = dateSplit[1];
    const day = dateSplit[2];
    const dateString = `${year}-${month}-${day}`;
    return dateString;
    }else{
      return null
    }
  }

    // drugs search HPI section Treatment Flow
    public drugsSearch(drugTerm : string): Observable<any> {
      if (!drugTerm) {
        return of([]).pipe(delay(500));
      }
      // const action = `drug/getDrugs/${drugTerm}`;
      const action = `changeHealth/getDrugByName?name=${drugTerm}`;
      const subItem = this.makeGetRequest(action);
      return subItem;
    }

       // common clear form array
  public clearFormArray(formArray: FormArray): void {
    while (formArray?.length !== 0) {
      formArray.removeAt(0)
    }
  }

   public getSelectedTime(date: any): string {
    if (date) {
      const splitDate = date?.toString()?.split('T');
      const timeSplit = splitDate[1]?.split(':');
      const time = `${timeSplit[0]}:${timeSplit[1]}`;
      const timeConvert = this.timeConvert(time) || '';
      const _formateDate = this.convertAppointmentDate(splitDate && splitDate[0]);
      return `${timeConvert}`;
    } else {
      return 'N/A'
    }
  }


  public convertcallVisordob(appntDate: string): any {
    const dateArray = appntDate && appntDate.split('-');
    const dateString = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
    return dateString;
  }


}



